import axios, { AxiosInstance } from 'axios';
import backendUrl from '../backendUrl';
import { triggerUnauthorized } from '../utils/authEvents';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: backendUrl,
  timeout: 10000, // 10 second timeout
});

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(new Error('Request cancelled'));
    }

    if (error.code === 'ECONNABORTED') {
      return Promise.reject(new Error('Request timed out'));
    }

    // A 401 from an authed request means the stored token is invalid/expired
    // (e.g. after switching backends). Clear the dead session.
    if (error.response?.status === 401) {
      triggerUnauthorized();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
